import { setCookie } from "banco/util/cookies";

const BANNER_COOKIE_NAME = "show_home_banner_v_1";

export const setupDynamicBanner = (): void => {
  // Setup banner dismiss functionality
  document.addEventListener("DOMContentLoaded", () => {
    const dismissButton = document.getElementById("dismiss-home-banner-btn");
    if (dismissButton) {
      dismissButton.addEventListener("click", () => {
        setCookie(BANNER_COOKIE_NAME, "false", { path: "/", secure: true, sameSite: "lax" });
        const homeBanner = document.querySelector(".home-banner") as HTMLElement;
        if (homeBanner) {
          homeBanner.style.display = "none";
        }
      });
    }
  });
};
